/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const RigOffshoreBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M8 1.5a.5.5 0 0 1 1 0V2h3.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-.587l1.377 8.95.001.002v.002L13.604 15H15v-4.217a.5.5 0 0 1 .388-.488l5-1.154A.5.5 0 0 1 21 9.63V15h.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H19v3h-4v-3H9v3H5v-3H2.5a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h.895l.315-2.046-.001-.002.001-.002L5.087 4H4.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H8v-.5ZM9 4h1.395l.365 2.37L9 8.014V4Zm.379 5.3 1.601-1.495.537 3.49L9.38 9.3ZM9 10.587l2.812 2.624.275 1.789H9v-4.413ZM6.605 4 6.24 6.37 8 8.014V4H6.605ZM6.02 7.805l-.538 3.491L7.622 9.3 6.02 7.805Zm-.832 5.407L4.913 15H8v-4.413l-2.812 2.625Z" /></svg>);
const RigOffshore = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={RigOffshoreBase} {...rest} ref={ref} />);
export default RigOffshore;